// export default Landing;
import React from "react";
import { Link } from "react-router-dom";
import styles from "./Landing.module.css";
import nycImage from "../../images/nyc.jpg";
import PropertyTypes from "components/property-types/Property-Types";

const LandingPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.logo}>PropertyTrack</h1>
        <div className={styles.headerButtons}>
          <Link to="/login" className={styles.loginButton}>
            Login
          </Link>
          <Link to="/signup" className={styles.registerButton}>
            Get Started
          </Link>
        </div>
      </header>

      <main className={styles.main}>
        <section className={styles.hero}>
          <div className={styles.heroContent}>
            <h2 className={styles.heroTitle}>
              Simplify Your Property Management
            </h2>
            <p className={styles.heroSubtitle}>
              Track rental payments, manage properties, and streamline your
              landlord duties with ease.
            </p>
            <div className={styles.heroCta}>
              <Link to="/signup" className={styles.registerButton}>
                Create Your Account
              </Link>
              <Link to="/login" className={styles.loginButton}>
                Log In to Your Account
              </Link>
            </div>
          </div>
          <div className={styles.heroImage}>
            <img src={nycImage} alt="Property management dashboard Test" />
          </div>
        </section>

        <section id="features" className={styles.features}>
          <h3 className={styles.sectionTitle}>What You’ll Love</h3>
          <div className={styles.featureGrid}>
            {[
              {
                title: "Effortless Rent Tracking",
                description:
                  "Stay on top of rental payments with ease—no more forgetting who has paid or due dates. Track multiple payments, payment reminders, and a clear financial overview in one place",
              },
              {
                title: "Portfolio at a Glance",
                description:
                  "Instantly see the status of all your properties—rents, occupancy, expenses, and more—all in one clear, organized view. Stay in control without the hassle.",
              },
              {
                title: "Tenant Manangement",
                description:
                  "Easily track tenants, upload leases, track due dates and lease start and end dates. Happy tenants, less stress.",
              },
              {
                title: "Smart Financial Insights",
                description:
                  "Gain clarity on your rental income and expenses with auto-generated reports. Make informed decisions and maximize your profits with ease",
              },
            ].map((feature, index) => (
              <div key={index} className={styles.featureItem}>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section id="pricing" className={styles.pricing}>
          <h3 className={styles.sectionTitle}>Simple, Transparent Pricing</h3>
          <p className={styles.sectionSubtitle}>
            Powerful tools, zero cost. Start managing your rentals today.
          </p>

          <div className={styles.pricingCard}>
            <div className={styles.priceBadge}>
              <span className={styles.priceText}>Free</span>
            </div>

            <h4 className={styles.planTitle}>Enterprise</h4>

            <ul className={styles.pricingFeatures}>
              <li>✓ Unlimited rent tracking</li>
              <li>✓ Smart tenant management</li>
              <li>✓ AI-powered financial reports</li>
              <li>✓ Secure document uploads</li>
            </ul>

            <Link to="/signup" className={styles.primaryButton}>
              Get Started Now →
            </Link>

            <p className={styles.disclaimer}>No credit card required.</p>
          </div>
        </section>

        {/* <section id="pricing" className={styles.pricing}>
          <h3 className={styles.sectionTitle}>Transparent Pricing</h3>
          <div className={styles.pricingCard}>
            <h4>Enterprise</h4>
            <p>Free</p>
            <ul className={styles.pricingFeatures}>
              <li>Unlimited rent tracking</li>
              <li>Tenant management</li>
              <li>Financial reports</li>
              <li>Document Uploads</li>
            </ul>
            <Link to="/signup" className={styles.secondaryButton}>
              Get Started Now!
            </Link>
          </div>
        </section> */}

        <section>
          <PropertyTypes />
        </section>

        <section id="contact" className={styles.contact}>
          <h3 className={styles.sectionTitle}>Get in Touch</h3>
          <p>Have questions? We're here to help.</p>
          <Link to="/contact" className={styles.secondaryButton}>
            Contact Us
          </Link>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>
          &copy; {new Date().getFullYear()} RoloniumLabs. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default LandingPage;
